"use client";

import { Box, useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";

interface MainContentProps {
  children: React.ReactNode;
}

const MainContent: React.FC<MainContentProps> = ({ children }) => {
  const [scrolled, setScrolled] = useState(false);
  const isMobile = useMediaQuery("(max-width:991px)");
  const isDesktop = !isMobile;

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 0);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Box
      sx={{
        marginTop: {
          legacyDesktop: scrolled && isDesktop 
            ? "calc(80px + var(--banner-height, 0px))"
            : "calc(130px + var(--banner-height, 0px))"
        }, transition: "margin-top 0.3s"
      }}
    >
      <Box component="main">
        {children}
      </Box>
    </Box>
  );
};

export default MainContent;